import { LANGUAGES_DEEPL } from './subtitles';

export const TRANSLATION_GLOSSARY_IMPORT_MAX_FILE_SIZE = 1024 ** 2 * 20; // 20MB

export const TRANSLATION_GLOSSARY_AVAILABLE_LANGUAGES = Array.from(
  new Set(Object.values(LANGUAGES_DEEPL).map(({ languageCode }) => languageCode.split('-')[0] as string))
);
